import { RotateCwIcon, TriangleAlertIcon } from 'lucide-react';
import { AppShell } from '@/flows/marketplace/components/app-shell.js';
import { Button } from '@/components/button.js';
import { Card, CardIntro } from '@/flows/marketplace/components/card.js';
import { DealerContactLink } from '@/flows/marketplace/components/dealer-contact-link.js';
import { resetSession } from '@/state/session.js';
import { step } from '@/flows/marketplace/state/step.js';

interface ErrorScreenProps {
  /** Clears the enclosing error boundary so the marketplace subtree remounts. */
  onReset?: () => void;
}

/** "Try again" resets the rating session to the entry step and clears the boundary. */
export function ErrorScreen({ onReset }: ErrorScreenProps) {
  function handleTryAgain() {
    resetSession();
    step.value = 'entry';
    onReset?.();
  }

  return (
    <AppShell faq={false}>
      <Card className="sm-card-centered">
        <div className="sm-center sm-badge" data-tone="error">
          <TriangleAlertIcon size={30} strokeWidth={2.5} aria-hidden="true" />
        </div>

        <CardIntro
          title="Something went wrong"
          subtitle="We couldn't complete your last step. Nothing was charged."
        />

        <div className="sm-stack sm-actions">
          <Button onClick={handleTryAgain} endIcon={<RotateCwIcon size={16} aria-hidden="true" />}>
            Try again
          </Button>
          <DealerContactLink />
        </div>
      </Card>
    </AppShell>
  );
}
